import React, { Dispatch, SetStateAction, useState } from "react";
import { MdOutlineTimer } from "react-icons/md";
import { HiSelector } from "react-icons/hi";
import {
  Box,
  Button,
  Grid2,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";

type OptionType = {
  title: string;
  value: string;
};

interface ITimeOptions {
  grids: {
    title: string;
    options: OptionType[];
  }[];
  option?: OptionType;
  setOption?: Dispatch<SetStateAction<OptionType | undefined>>;
}

function TimeOptions({ grids, option, setOption }: ITimeOptions) {
  const [anchorMenu, setAnchorMenu] = useState<HTMLElement | null>();

  const handleCloseMenu = () => {
    setAnchorMenu(null);
  };

  return (
    <>
      <Menu
        anchorEl={anchorMenu}
        open={!!anchorMenu}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        onClose={handleCloseMenu}
      >
        <Box sx={{ width: "90vw", maxWidth: "600px", padding: "10px" }}>
          <Grid2 container spacing={1}>
            {grids.map((grid) => (
              <Grid2 key={grid.title} size={{ xs: 2.4 }}>
                <Stack sx={{ width: "100%" }} spacing="5px" alignItems="center">
                  <Typography sx={{ fontSize: "14px", fontWeight: "550" }}>
                    {grid.title}
                  </Typography>
                  {grid.options.map((option) => (
                    <MenuItem
                      key={option.title}
                      sx={{
                        fontSize: "14px",
                        color: "primary.main",
                        padding: "2px 4px",
                      }}
                      onClick={() => {
                        setOption?.(option);
                        handleCloseMenu();
                      }}
                    >
                      {option.title}
                    </MenuItem>
                  ))}
                </Stack>
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </Menu>
      <Button
        variant="outlined"
        startIcon={<MdOutlineTimer size={16} />}
        endIcon={<HiSelector size={16} />}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          textTransform: "none",
        }}
        onClick={(e) => setAnchorMenu(e.currentTarget)}
      >
        {!!option ? option.title : "Tùy chọn"}
      </Button>
    </>
  );
}

export default TimeOptions;
